var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBectangleBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 779,
    height: 87,
    viewBox: "0 0 779 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -59.9966H779V40.0032C779 40.0032 739 97.0032 654.5 40.0032C570 -16.9966 525 -2.99656 493 33.5034C461 70.0032 402.5 129.003 313 40.0032C223.5 -48.9966 212 111.003 113.5 40.0032C15 -30.9966 0 40.0032 0 40.0032V-59.9966Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 779,
    height: 87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBectangleBottom);
export default __webpack_public_path__ + "static/media/bg-bectangle-bottom.85f8c1f286bf6dade2eff42ce1b3e65c.svg";
export { ForwardRef as ReactComponent };